import { Card, CardContent, Typography, Box, Select, MenuItem, FormControl, InputLabel } from "@mui/material";
//import { HomeWork } from "@mui/icons-material";//
import { useDispatch, useSelector } from "react-redux";

import { colors, alphaVar } from "../../../../../../../ui/colors";
import { SASInputStyles } from "../../../../../../../ui/styles/inputStyles";
import { menuPropsModal } from "../../../../../../../../utils";
import { quoteCreateActions } from "../../../../../../../../redux/features/quotes/quote-create-advanced";

const SQUARE_FT_RANGES = [
  { value: "0-1000", label: "0 - 1,000 sq ft" },
  { value: "1001-2000", label: "1,001 - 2,000 sq ft" },
  { value: "2001-3000", label: "2,001 - 3,000 sq ft" },
  { value: "3001-4000", label: "3,001 - 4,000 sq ft" },
  { value: "4001-5000", label: "4,001 - 5,000 sq ft" },
  { value: "5001", label: "5,001+ sq ft" },
];

export const TypeOfPlaceCard = ({ place, onSelect, selected }) => {
  const dispatch = useDispatch();
  const { addSquareft } = quoteCreateActions;

  const squareft = useSelector((state) => state.quoteCreate.sectorWorkflow.squareft);

  const handleRangeChange = (e) => {
    const value = e.target.value;
    dispatch(addSquareft(value));
  };

  return (
    <Card
      onClick={() => onSelect?.(place)}
      sx={{
        backgroundColor: selected ? alphaVar(colors.orange[50], 0.6) : "var(--fx-surface-base, #FFFFFF)",
        borderRadius: 2,
        border: `2px solid ${selected ? colors.orange.base : alphaVar(colors.gray[100], 0.8)}`,
        boxShadow: selected ? `0 3px 8px ${alphaVar(colors.orange.base, 0.25)}` : "0 1px 2px rgba(0,0,0,0.05)",
        cursor: "pointer",
        transition: "all 0.2s ease",
        overflow: "hidden",
        maxWidth: 250,
        "&:hover": {
          transform: "translateY(-1px)",
          boxShadow: `0 3px 6px ${alphaVar(colors.orange.base, 0.15)}`,
          borderColor: alphaVar(colors.orange.base, 0.3),
        },
        display: "flex",
        flexDirection: "column",
      }}
    >
      <CardContent
        sx={{
          flex: "1 1 auto",
          p: 1.5,
          display: "flex",
          flexDirection: "column",
          justifyContent: "flex-start",
        }}
      >
        <Box
          component="img"
          src={place.imageUrl}
          alt={place.name}
          sx={{
            width: 170,
            height: 170,
            borderRadius: "50%",

            color: colors.orange.base,
            display: "flex",
            alignItems: "center",
            margin: "auto",
            marginTop: -3,

            justifyContent: "center",
            mb: 1,
            flexShrink: 0,
          }}
        ></Box>

        <Typography
          variant="subtitle2"
          fontWeight={700}
          sx={{
            color: selected ? colors.orange[700] : colors.gray[500],
            fontSize: 16,
            mb: 0.5,
            marginTop: -4,
            whiteSpace: "nowrap",
            textOverflow: "ellipsis",
            overflow: "hidden",
          }}
        >
          {place.name}
        </Typography>

        <Typography
          variant="body2"
          sx={{
            color: colors.gray[300],
            fontSize: 14,
            lineHeight: 1.2,
            mb: 1,
            overflow: "hidden",
            textOverflow: "ellipsis",
            display: "-webkit-box",
            WebkitLineClamp: 2,
            WebkitBoxOrient: "vertical",
          }}
        >
          {place.description}
        </Typography>

        <Box
          sx={{
            px: 0.7,
            py: 0.2,
            fontSize: 9,
            fontWeight: 600,
            textTransform: "uppercase",
            borderRadius: 1,
            backgroundColor: alphaVar(colors.orange[100], 0.25),
            color: colors.orange[700],
            width: "fit-content",
            mb: selected ? 1.5 : 0,
          }}
        >
          {place.category?.name || "—"}
        </Box>

        {selected && (
          <Box sx={{ display: "flex", flexDirection: "column", gap: 2 }}>
            <FormControl fullWidth size="small" sx={SASInputStyles}>
              <InputLabel id={`sqft-range-label-${place.uid}`}>Square footage range</InputLabel>
              <Select
                MenuProps={menuPropsModal}
                labelId={`sqft-range-label-${place.uid}`}
                label="Square footage range"
                value={squareft || ""}
                onChange={handleRangeChange}
              >
                {SQUARE_FT_RANGES.map((range) => (
                  <MenuItem key={range.value} value={range.value}>
                    {range.label}
                  </MenuItem>
                ))}
              </Select>
            </FormControl>
          </Box>
        )}
      </CardContent>
    </Card>
  );
};
